export default __webpack_public_path__ + "static/assets/hero.e0440c2a.jpg";